import { c as _c } from "react/compiler-runtime";
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { PaymentElement } from '@stripe/react-stripe-js';
import { useInputClassNames } from '@winelidays/wld-tsx-2/fields';
import { getFormDataAttributes } from '@winelidays/wld-tsx-2/utils';
import { useEffect, useState } from 'react';
const PaymentInput = (t0) => {
    const $ = _c(29);
    const { formId, id: fieldId, error: incomingError, showError, setErrorStatus, onChange, hideLabel: t1, floatingLabel: t2, inline: t3 } = t0;
    const hideLabel = t1 === undefined ? false : t1;
    const floatingLabel = t2 === undefined ? false : t2;
    const inline = t3 === undefined ? false : t3;
    const translate = useTranslate();
    const id = `${formId}-${fieldId}`;
    const [isComplete, setIsComplete] = useState(false);
    let t4;
    if ($[0] !== onChange) {
        t4 = (e) => {
            setIsComplete(e.complete);
            if (onChange !== undefined) {
                onChange();
            }
        };
        $[0] = onChange;
        $[1] = t4;
    }
    else {
        t4 = $[1];
    }
    const handleChange = t4;
    let t5;
    if ($[2] !== isComplete || $[3] !== translate) {
        t5 = !isComplete ? translate("form.error.stripe.incomplete") : null;
        $[2] = isComplete;
        $[3] = translate;
        $[4] = t5;
    }
    else {
        t5 = $[4];
    }
    const localError = t5;
    let t6;
    let t7;
    if ($[5] !== localError || $[6] !== setErrorStatus) {
        t6 = () => {
            if (setErrorStatus) {
                setErrorStatus(!!localError);
            }
        };
        t7 = [setErrorStatus, localError];
        $[5] = localError;
        $[6] = setErrorStatus;
        $[7] = t6;
        $[8] = t7;
    }
    else {
        t6 = $[7];
        t7 = $[8];
    }
    useEffect(t6, t7);
    const error = incomingError ?? localError;
    const inError = !!(showError && error);
    let t8;
    if ($[9] !== floatingLabel || $[10] !== hideLabel || $[11] !== inError || $[12] !== inline) {
        t8 = { inError, empty: false, hideLabel, floatingLabel, hint: null, inline };
        $[9] = floatingLabel;
        $[10] = hideLabel;
        $[11] = inError;
        $[12] = inline;
        $[13] = t8;
    }
    else {
        t8 = $[13];
    }
    const { containerClassName, errorClassName } = useInputClassNames(t8);
    let t9;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = { layout: "accordion", paymentMethodOrder: [
                "apple_pay", "google_pay", "card"
            ] };
        $[14] = t9;
    }
    else {
        t9 = $[14];
    }
    const options = t9;
    let t10;
    if ($[15] !== error || $[16] !== formId) {
        t10 = getFormDataAttributes({ formId, error, isAutofilled: false });
        $[15] = error;
        $[16] = formId;
        $[17] = t10;
    }
    else {
        t10 = $[17];
    }
    const formData = t10;
    let t11;
    if ($[18] !== handleChange || $[19] !== id) {
        t11 = <PaymentElement id={id} className="max-w-112 text-sm! font-semibold!" onChange={handleChange} options={options}/>;
        $[18] = handleChange;
        $[19] = id;
        $[20] = t11;
    }
    else {
        t11 = $[20];
    }
    const t12 = inError && error;
    let t13;
    if ($[21] !== errorClassName || $[22] !== t12) {
        t13 = <p className={errorClassName}>{t12}</p>;
        $[21] = errorClassName;
        $[22] = t12;
        $[23] = t13;
    }
    else {
        t13 = $[23];
    }
    let t14;
    if ($[24] !== containerClassName || $[25] !== formData || $[26] !== t11 || $[27] !== t13) {
        t14 = <div className={containerClassName} {...formData}>{t11}{t13}
    </div>;
        $[24] = containerClassName;
        $[25] = formData;
        $[26] = t11;
        $[27] = t13;
        $[28] = t14;
    }
    else {
        t14 = $[28];
    }
    return t14;
};
export default PaymentInput;
